<template>
  <div class="main">
    <div class="main_top">
      <div class="schoolBtn">
        <!-- <Button
          Icon
          icon="md-trash"
        >
          导入模板下载
        </Button>
        <Button
          Icon
          icon="md-trash"
        >
          导入
        </Button> -->
        <Model
          msg="新增"
          icon="md-add"
          @SchoolTreeList='getschoolDataList'
        ></Model>
        <Model
          msg="编辑"
          icon="ios-create"
          :schoolChange="schoolChange"
          @SchoolTreeList='getschoolDataList'
        ></Model>
        <Button
          Icon
          icon="md-trash"
          @click="deleteSchool"
          @SchoolTreeList='getschoolDataList'
        >
          删除
        </Button>
      </div>
    </div>
    <div class="main_body">
      <el-table
        :data="schoolDataList"
        stripe
        highlight-current-row
        @current-change="handleCurrentChange"
        row-key="schoolid"
        style="width: 100%"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        >
        <el-table-column
          type="index"
          width="80"
          label="序号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="schoolname"
          label="学校名称"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="enshortname"
          label="英文名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="cnshortname"
          label="中文简称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="schoolnaturename"
          label="学校性质"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="foundedtime"
          label="成立时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="manager"
          label="负责人"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          label="备注"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'
import Model from '../../components/schoolModal'

export default {
  data () {
    return {
      schoolChange: {},
      schoolDataList: [],

    }
  },
  components: {
    Model: Model,
  },

  watch: {

  },
  mounted () {
  },
  methods: {
    //获取学校信息列表
    async GetSchoolTreeList () {
      const res = await Api.school.GetSchoolTreeList()
      if (res.success != true) return this.Message(res.msg)
      this.schoolDataList = res.rows;
      this.$emit('SchoolTreeList', res.rows)
    },
    getschoolDataList (data) {
      this.schoolDataList = data
    },
    //学校表格选中项
    handleCurrentChange (val) {
      this.schoolChange = val;
    },
    //删除学校
    deleteSchool () {
      if (JSON.stringify(this.schoolChange) == '{}') {
        return this.$Message.info('请选择删除项')
      }
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await Api.school.DelSchoolInfo([this.schoolChange.schoolid])
        if (res.success) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
        this.GetSchoolTreeList()
      }).catch(() => {

      });

    }

  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .main_top {
    height: 60px;
    padding: 10px 15px 0 0;
    .schoolBtn {
      float: right;
      /deep/.ivu-btn {
        padding: 0 10px;
      }
      display: flex;
      > div {
        margin-right: 5px;
      }
      > button {
        margin-right: 5px;
      }
    }
  }
}
</style>